import { AppProblemModel } from '@/services/api/AppProblemModel'
import { resolveProblemMessage } from '@/services/api/resolveProblemMessage'
import { problemTitle } from '@/services/api/problemTitle'
import { usePresentationTranslator } from '@/composables/usePresentationTranslator'
import { useLogger } from '~/composables/useLogger'
import { useToast } from '~/composables/useToast'

const logger = useLogger('ApiErrorHandler')

export function errorHandler(
  error: unknown,
  fallback?: string,
  type: 'error' | 'warning' = 'error'
) {
  const $toast = useToast()
  const t = usePresentationTranslator()
  const problem = AppProblemModel.normalize(error)
  const detail = resolveProblemMessage(problem, t, fallback)

  logger.error('handleApiError', { error, detail })
  if (problem.isBrandSetupRequired) return
  if (type === 'error') $toast.error(problemTitle(problem), { description: detail })
  else if (type === 'warning') $toast.warning(problemTitle(problem), { description: detail })
}
